import { css } from 'styled-components'

// Note: Thin visible scrollbar with consistent styling across browsers
export const thinScrollbar = css`
  /* Webkit (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: ${({ theme }) => theme.space['4']};
    height: ${({ theme }) => theme.space['4']};
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.gray500};
    border-radius: ${({ theme }) => theme.border.radius['4']};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => `${theme.colors.gray500} transparent`};
`

// Note: Hidden scrollbar while keeping scroll functionality
export const hiddenScrollbar = css`
  /* Webkit (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* IE and Edge */
  -ms-overflow-style: none;

  /* Firefox */
  scrollbar-width: none;
`
